import React from 'react';
import {useTranslation} from 'react-i18next';
import {LANGS} from '../../incase-domain/widgets/languageSelector/LanguageSelector';
import i18n from '../../i18n';
import DropdownMenuCompact, {DropdownMenuCompactMenuPosition} from '../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import Button from '../../incase-domain/components/button/Button';

function LanguageSelectorDropdown(): JSX.Element {
    const {t} = useTranslation();

    const selectedLang = LANGS.find((lang) => lang.value === i18n.language);

    return (
        <DropdownMenuCompact
            items={[
                [
                    {
                        label: t('header.languageSelector.hr'),
                        icon: 'emojione:flag-for-croatia',
                        onClick: () => i18n.changeLanguage('hr'),
                        active: i18n.language === 'hr',
                    },
                    {
                        label: t('header.languageSelector.en'),
                        icon: 'emojione:flag-for-united-kingdom',
                        onClick: () => i18n.changeLanguage('en'),
                        active: i18n.language === 'en',
                    },
                ],
            ]}
            menuPosition={DropdownMenuCompactMenuPosition.LEFT}
        >
            <Button leading={selectedLang?.flag || 'ph:globe'} size="xl" variant="ghost" square />
        </DropdownMenuCompact>
    );
}

export default LanguageSelectorDropdown;
